<ng-container *ngIf="!!filterSet">
  <ng-container *ngIf="filterSet.style === 'standard'">
    <div class="filter-set-standard d-flex flex-column">
      <ng-container *ngIf="filterSet.filters?.length > 0 || !!filterSet.toggle">
        <div class="filter-row d-flex justify-content-between align-items-center mx-n3 mx-sm-0">
          <!-- filter(s) -->
          <ng-container *ngIf="filterSet.filters?.length > 0">
            <div class="flex-grow-1 overflow-auto">
              <flo-filters [items]="filterSet.filters"></flo-filters>
            </div>
          </ng-container>

          <!-- toggle -->
          <ng-container *ngIf="!!filterSet.toggle">
            <div class="ms-auto">
              <flo-filters [items]="[filterSet.toggle]"></flo-filters>
            </div>
          </ng-container>
        </div>
      </ng-container>

      <!-- segmented control -->
      <ng-container *ngIf="filterSet.segmentedControls?.length > 0">
        <div class="segmented-control-grid">
          <ng-container *ngFor="let segmentedControl of filterSet.segmentedControls">
            <flo-segmented-control [segmentedControl]="segmentedControl"></flo-segmented-control>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </ng-container>
</ng-container>